import React, { useEffect, useState, useMemo } from "react";
import jsPDF from "jspdf";
// import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { Link } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import { ERROR_MESSAGE , CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import { toastError } from "../../../common/Toast";
import CleanupConfirmationModal from "../../../components/Modal/CleanupConfirmation";
import SkipbarcodeConfirmationModal from "../../../components/Modal/barcodesheetmodal";
import { checkUserPermission } from "../../../common/UserPermission";
import Select from "react-select";
import * as XLSX from "xlsx";
import { Noimage } from "../../../common/imagePath";
import moment from "moment";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import DeleteAccountConfirmation from "../../../components/Modal/DeleteAccountConfirmation";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "/manage-customers";
let PERMISSION_EDIT = "/manage-customers/:id";
let PERMISSION_DELETE = "delete-customers";
let PERMISSION_MANAGE_DELETED_CUSTOMERS = "/deleted-customers";
let PERMISSION_EXCEL_IMPORT = "/import-excel-customers";
let PERMISSION_EXCEL_EXPORT = "excel-export-customers";
let PERMISSION_CLEANUP_OLD_CUSTOMERS = "cleanup-old-customers";
let PERMISSION_CUSTOM_FIELD_CONFIGURATION = "/custom-field-configuration";
let PERMISSION_CUSTOMER_INTAKE_FORM = "/customer-intake-form";

let PERMISSION_EMAIL_CUSTOMERS = "email-customers";
let PERMISSION_MAILING_LABELS = "mailing-labels-customers";
let PERMISSION_BARCODE_LABELS = "barcode-labels-customers";
let PERMISSION_BARCODE_SHEETS = "barcode-sheets-customers";


export const InventoryAdjustment = () => {
  let selectData = [];
  let pathforpdf = "";
  let selectDatas = [];
  // let excelalldata;
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [sortingId, setSortingId] = useState(6);
  const [state, setState] = useState("");

  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [selectedCustomerCheckboxs, setselectedCustomerCheckbox] = useState("");
  const [selectedCustomerCheckEmails, setselectedCustomerCheckEmails] =
    useState("");
  const [selectedCustomerCheckpathforpdf, setselectedCustomerCheckpathforpdf] =
    useState("");
  const [selectedCustomerBarcodeLabel, setselectedCustomerBarcodeLabel] =
    useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [selectedDataDelete, setSelectedDataDelete] = useState("");

  const options = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");

  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();

  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "30px",
  //     position: "relative",
  //     // border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     // boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     // "&:hover": {
  //     //   border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     // },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     // backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     // "&:hover": {
  //     //   backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     // },
  //   }),
  // };

  //BARCODE
  const handlebarcodesheet = (pID) => {
    const barcodeRequestParam = pID;
    //   Barcode_Id: pID,
    // };
    localStorage.setItem(
      "BarcodeRequestParam",
      barcodeRequestParam
      // JSON.stringify(barcodeRequestParam)
    );

    getCustomerDetailsForLabelById(barcodeRequestParam);
  };

  const getCustomerDetailsForLabelById = (barcodeRequestParam) => {
    axios
      .get(
        `${config.customersBaseUrl}/customers/customerdetailforlabel?id=${barcodeRequestParam}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // setFormValues(res.data.ResponseData);
        console.log(res.data);
        console.log(res.data.ResponseData);
      });
  };

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingdate,
    endingdate
  ) => {
    setLoading(true);
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/inventoryquantityselectall?pagenumber=${pagenumber}&pagesize=${pagesize}&filtertext=${filtertext}&ordercolumn=${ordercolumn}&currentorder=${currentorder}&startdate=${startingdate}&enddate=${endingdate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // pdf make onclick

  

  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      // for get detlais form id
      setSelectedRows(e.selectedRows.map((x) => x.Id));
      selectData[currentPage] = e.selectedRows.map((x) => x.Id);
      const selectedCustomerCheckboxIDs =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      const selectedDataDelete =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setSelectedDataDelete(selectedDataDelete);
      setselectedCustomerCheckbox(selectedCustomerCheckboxIDs);
      const datasplitforpath = selectedCustomerCheckboxIDs?.split(",");
      pathforpdf = datasplitforpath?.join("~");
      setselectedCustomerCheckpathforpdf(pathforpdf);
      console.log("Datasasasa", pathforpdf);

      // get emails of selectdids
      setSelectedRows(e.selectedRows.map((x) => x.Email));
      selectData[currentPage] = e.selectedRows.map((x) => x.Email);
      const selectedCustomerCheckboxEmails =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedCustomerCheckEmails(selectedCustomerCheckboxEmails);
      console.log(selectedCustomerCheckboxEmails);
    }
  };

  const handleDeletePopup = (pID) => {
    console.log(pID);
    const deleteRequestParam = pID
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
  };

  const contextActions = useMemo(() => {
    // for handling barcode label
    const handlebarcode = (pID) => {
      const barcodeRequestParam = pID;

      localStorage.setItem(
        "BarcodeRequestParam",
        barcodeRequestParam
        // JSON.stringify(barcodeRequestParam)
      );
    };

    // For handle pdf
    const handlepdf = () => {
      console.log("Enyer", selectedCustomerCheckboxs);
      axios
        .get(
          `${config.customersBaseUrl}/customers/customerdetailforlabel?id=${selectedCustomerCheckboxs}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const doc = new jsPDF();

          let position = 0;
          for (let i = 0; i < res.data.ResponseData.length; i++) {
            console.log(res.data.ResponseData.length);
            position = position + 10;
            doc.setFontSize(10);

            doc.text(
              `FirstName: ${res.data.ResponseData[i].FirstName}`,
              10,
              position
            );
            position = position + 10;
            doc.text(
              `LastName: ${res.data.ResponseData[i].LastName}`,
              10,
              position
            );
            position = position + 10;
            doc.text(`Email: ${res.data.ResponseData[i].Email}`, 10, position);
            position = position + 10;
            doc.text(`City: ${res.data.ResponseData[i].City}`, 10, position);
            position = position + 10;
            doc.text(
              `Address1: ${res.data.ResponseData[i].Address1}`,
              10,
              position
            );
            console.log(res.data.ResponseData);

            position = position + 10;

            if ((i + 1) % 4 == 0) {
              doc.addPage();
              position = 0;
            } else if (i == res.data.ResponseData.length - 1) {
            }
          }
          //   doc.deletePage(Last);
          doc.save(`Customers_mailing_label${Date.now()}.pdf`);
          setState({ data: res.data.ResponseData });
        });
    };

    return (
      <>
        <div className="row px-2 ">
          <div className="col-12 align-self-center">
            {checkUserPermission(PERMISSION_EMAIL_CUSTOMERS) ? (
              <a href={"mailto:" + selectedCustomerCheckEmails}>
                <button type="button" className="btn btn-dark btn-sm ">
                  <i className="fa fa-envelope fa-sm" /> E-mail
                </button>
              </a>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="row px-2">
          <div className="col-12 align-self-center">
            {/* <a href={"/mailing_labels/" + selectedCustomerCheckpathforpdf}> */}
            {checkUserPermission(PERMISSION_MAILING_LABELS) ? (
              <button
                type="button"
                className="btn btn-dark btn-sm"
                title="MailingLabels"
                onClick={handlepdf}
              >
                <i className="fa fa-envelope-square fa-sm" /> Mailing-Labels
              </button>
            ) : (
              ""
            )}
            {/* </a> */}
          </div>
        </div>

        <div className="row px-2 ">
          <div className="col-12 align-self-center">
            {checkUserPermission(PERMISSION_BARCODE_LABELS) ? (
              <a href={"/customer-barcode-label"}>
                <button
                  type="button"
                  className="btn btn-dark btn-sm"
                  onClick={handlebarcode(selectedCustomerCheckboxs)}
                >
                  <i className="fa fa-envelope-square fa-sm" /> Barcode Labels
                </button>
              </a>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="row px-2">
          <div className="col-12 align-self-center">
            {/* () => setLgShow(true) */}
            {checkUserPermission(PERMISSION_BARCODE_SHEETS) ? (
              <button
                type="button"
                className="btn btn-dark btn-sm"
                data-bs-toggle="modal"
                data-bs-target="#BarcodeSheetModal"
                title="MailingLabels"
                onClick={handlebarcodesheet(selectedCustomerCheckboxs)}
              >
                <i className="fa fa-envelope-square fa-sm" /> Barcode-Sheets
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="row px-2">
          <button
            type="button"
            className="btn btn-danger btn-sm pull-left "
            data-bs-toggle="modal"
            data-bs-target="#DeleteConfirmationModal"
            onClick={() => handleDeletePopup()}
          >
            <i className="fa fa-trash fa-sm" /> Delete Selected
          </button>
        </div>
      </>
    );
  }, [data, selectedRows, toggleCleared]);

  const formatDate = (string) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  };

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate
    );
  };

  useEffect(() => {
    if (quickBookOptions?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    // else if (quickBookOptions?.value == 2) {
    //   setStartingDate(customStartingDate);
    //   setEndingDate(customEndingDate);
    // }
    // Last Week Condition
    else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DD');
      const lastWeekEndDate = moment().subtract(1, 'week').endOf('week').format('YYYY-MM-DD');
  
      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
    const currentWeekStartDate = moment().startOf('week').format('YYYY-MM-DD');
      const currentWeekEndDate = moment().endOf('week').format('YYYY-MM-DD');
  
      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
     
      const lastMonthStartDate = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
      const lastMonthEndDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
  
      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    } 
    //currentmonth
    else if (quickBookOptions?.value == 6) {
        const currentFirstDate = moment().startOf('month').format('YYYY-MM-DD');
      const currentLastDate = moment().endOf('month').format('YYYY-MM-DD');
  
      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  }, [quickBookOptions]);
  
  useEffect(() => {
    if (quickBookOptions?.value !== 2) {
      handleListData(
        1,
        perPageSize,
        searchtext,
        sortingId,
        sortingDirection,
        startingDate,
        endingDate,
      );
    }
  }, [ quickBookOptions]);
  
  

  // Table Data
  const columns = [
    {
      name: "S.NO",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "80px",
    },
    {
      name: "Adjustment Date",
      selector: (row) => formatDate(row.AdjusmentDate),
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Name",
    //   // selector: (row) => row.FirstName + " " + row.LastName,
    //   sortable: true,
    //   cell: (row) => (
    //     <>
    //     <Link class="text-dark" to={`/manage-customers/${row.Id}`}>
    //       {row.FirstName} {" "} {row.LastName}
    //     </Link>
    //     </>
    //   ),
      
    //   width: "130px",

    // },
    {
      name: "Inventory Adjustment Account",
      selector: "InventoryAdjusmentAccount",
      sortable: true,
      width: "280px",
    },
    {
      name: "Memo",
      selector: "Memo",
      sortable: true,
      width: "170px",
    },
    // {
    //   name: "Profile",
    //   selector: "Image",
    //   sortable: true,
    //   cell: (row) => (
    //     <>
    //       <a href={row.Image} target="_blank"><img
    //         src={row.Image}
    //         alt="Profile Image"
    //         style={{
    //           maxWidth: "30px",
    //           maxHeight: "70px",
    //           margin: "5px",
    //         }}
    //         onError={(e) => {
    //           e.target.onerror = null;
    //            // style={{
    //         //   maxWidth: "70px",
    //         //   maxHeight: "70px",
    //         //   margin: "5px",
    //         // }}
    //           e.target.src = Noimage;
    //         }}
    //       ></img></a>
    //     </>
    //   ),
    // },
    
    {
      name: "Ref No",
      selector:"Refrenceno",
      sortable: true,
      width: "230px",
    },
    {
      name: "Action",
      // width: "20%",
      cell: (row) => (
        <>
          {checkUserPermission(PERMISSION_EDIT) ? (
            <Link className="me-3" to={`/manage-adjustment/${row.ID}`}>
              <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
            </Link>
          ) : (
            ""
          )}
          {checkUserPermission(PERMISSION_DELETE) ? (
            <Link
              className="confirm-text"
              to="#"
              title="Delete"
              data-bs-toggle="modal"
              data-bs-target="#DeleteConfirmationModal"
              onClick={() => handleDeletePopup(row.ID)}
            >
              <i
                className="fa fa-trash text-red fa-2x"
                data-bs-toggle="tooltip"
                title="Delete"
              ></i>
            </Link>
          ) : (
            ""
          )}
        </>
      ),
      // ignoreRowClick: true,
      // allowOverflow: true,
      // button: true,
    },
  ];

  // const handleSelectedRowsChange = (e) => {
  //     if (e.selectedRows.length > 0) {
  //         setSelectedData(e.selectedRows.map(x => x.ID));
  //         selectData[currentPage] = e.selectedRows.map(x => x.ID);
  //     }
  // }

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };

 

  // store checkbox checked values to hide or show columns
  // const handleExcelExport = () => {
  //   setLoading(true);
  //   axios({
  //     url: `${config.customersBaseUrl}/customers/exportexcel`,
  //     method: "POST",
  //     data: {
  //       filtertext: searchtext,
  //       ordercolumn: sortingId,
  //       currentorder: sortingDirection,
  //     },
  //     headers: {
  //       Authorization: token,
  //     },
  //     responseType: "blob", // set response type to blob
  //   })
  //     .then((res) => {
  //       const url = window.URL.createObjectURL(new Blob([res.data]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", "data.xlsx"); // set file name
  //       document.body.appendChild(link);
  //       link.click();
  //       toastSuccess(DATA_EXPORT);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       toastError(ERROR_MESSAGE);
  //       setLoading(false);
  //     });
  // };

  function handleCheckboxChange(columnName) {
    if (hiddenColumns.includes(columnName)) {
      setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
    } else {
      setHiddenColumns([...hiddenColumns, columnName]);
    }
  }

  // generate new columns according to hiddenColumns data and pass it as datatable column
  const filteredColumns = columns.filter(
    (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  );

  const handleChangeCustomStartingDate = (event) => {
    console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  const handleQuickBookChange = (fieldName, event) => {
    // console.log("Value ==> ", event);
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      var currentDateForLastWeek = new Date();
      // console.log("currentDateForLastWeek ==> ", currentDateForLastWeek);
      // Set the date to the start of the current week (Sunday)
      var startOfWeekForLastWeek = new Date(
        currentDateForLastWeek.setDate(
          currentDateForLastWeek.getDate() - currentDateForLastWeek.getDay()
        )
      );
      // console.log("startOfWeekForLastWeek ==> ", startOfWeekForLastWeek);

      // Set the date to the end of the last week (Saturday)
      var endOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(startOfWeekForLastWeek.getDate() - 1)
      );
      // console.log("endOfLastWeekForLastWeek ==> ", endOfLastWeekForLastWeek);

      // Set the date to the start of the last week (Sunday)
      var startOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(endOfLastWeekForLastWeek.getDate() - 6)
      );

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForLastWeek = startOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      var endDateStringForLastWeek = endOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      // Output the results
      // console.log(
      //   "Last week started on " +
      //     startDateStringForLastWeek +
      //     " and ended on " +
      //     endDateStringForLastWeek
      // );
      setStartingDate(startDateStringForLastWeek);
      setEndingDate(endDateStringForLastWeek);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      var currentDateForCurrentWeek = new Date();
      // console.log("currentDateForCurrentWeek ==> ", currentDateForCurrentWeek);

      // Set the date to the start of the current week (Sunday)
      var startOfWeekForCurrentWeek = new Date(
        currentDateForCurrentWeek.getTime() -
          currentDateForCurrentWeek.getDay() * 24 * 60 * 60 * 1000
      );
      // console.log("startOfWeekForCurrentWeek ==> ", startOfWeekForCurrentWeek);

      // Set the date to the end of the current week (Saturday)
      var endOfWeekForCurrentWeek = new Date(
        startOfWeekForCurrentWeek.getTime() + 6 * 24 * 60 * 60 * 1000
      );
      // console.log("endOfWeekForCurrentWeek ==> ", endOfWeekForCurrentWeek);

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForCurrentWeek = startOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      var endDateStringForCurrentWeek = endOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   "Current week started on " +
      //     startDateStringForCurrentWeek +
      //     " and ended on " +
      //     endDateStringForCurrentWeek
      // );

      setStartingDate(startDateStringForCurrentWeek);
      setEndingDate(endDateStringForCurrentWeek);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      // Get today's date
      const todayForLastMonth = new Date();

      // Get the first day of the current month
      const firstDayCurrentMonthForLastMonth = new Date(
        todayForLastMonth.getFullYear(),
        todayForLastMonth.getMonth(),
        1
      );

      // Get the last day of the previous month
      const lastDayPrevMonthForLastMonth = new Date(
        firstDayCurrentMonthForLastMonth.getTime() - 1
      );

      // Get the starting date of the previous month
      const firstDayPrevMonthForLastMonth = new Date(
        lastDayPrevMonthForLastMonth.getFullYear(),
        lastDayPrevMonthForLastMonth.getMonth(),
        1
      );

      // Format the starting and ending dates of the previous month as yyyy-mm-dd
      const startDateFormattedForLastMonth = firstDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForLastMonth = lastDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   `Starting date of last month: ${startDateFormattedForLastMonth}`
      // );
      // console.log(`Ending date of last month: ${endDateFormattedForLastMonth}`);
      setStartingDate(startDateFormattedForLastMonth);
      setEndingDate(endDateFormattedForLastMonth);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      // Get today's date
      const todayForCurrentMonth = new Date();

      // Get the first day of the current month
      const firstDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth(),
        1
      );

      // Get the last day of the current month
      const lastDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth() + 1,
        0
      );

      // Format the starting and ending dates of the current month as yyyy-mm-dd
      const startDateFormattedForCurrentMonth = firstDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForCurrentMonth = lastDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   `Starting date of current month: ${startDateFormattedForCurrentMonth}`
      // );
      // console.log(
      //   `Ending date of current month: ${endDateFormattedForCurrentMonth}`
      // );
      setStartingDate(startDateFormattedForCurrentMonth);
      setEndingDate(endDateFormattedForCurrentMonth);
    }
    else{
      setStartingDate("");
      setEndingDate("");
    }
  };

 

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">Accounting</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Inventory Adjustment</li>
                </ul>
              </div>
            </div>
            <div>
              {/* dynamically hide or show columns */}
              {/* <div className="btn-group pull-right ms-2 dropdown">
                <button
                  type="button"
                  className="btn btn-outline-primary dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  <i className="fa fa-cog"></i> &nbsp;
                </button>
                <div className="dropdown-menu">
                  {columns.map((column) =>
                    // omit Action column
                    column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                      <div
                        key={column.name.replace(/\s+|-|\/|#/g, "")}
                        className="form-check ms-2 mt-1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                          value={column.name.replace(/\s+|-|\/|#/g, "")}
                          checked={
                            !hiddenColumns.includes(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          } // check all checkboxes which are not include in hiddenColumns
                          onChange={() =>
                            handleCheckboxChange(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                        >
                          {column.name}
                        </label>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </div>
              </div> */}

              {/* <div className="btn-group pull-right ms-2">
                <button type="button" className="btn btn-outline-dark d-none">
                  More
                </button>
                <button
                  type="button"
                  className="btn btn-outline-dark dropdown-toggle me-1"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  More &nbsp;
                  {/* <span className="sr-only">Toggle Dropdown</span> */}
                {/* </button>
                <div className="dropdown-menu">
                  <li>
                    {checkUserPermission(PERMISSION_CUSTOMER_INTAKE_FORM) ? (
                      <Link class="dropdown-item" to="/customer-intake-form">
                        Customer Intake Form
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_EXCEL_IMPORT) ? (
                      <Link class="dropdown-item" to="/import-excel-customers">
                        Excel Import
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_EXCEL_EXPORT) ? (
                      <Link class="dropdown-item" onClick={handleExcelExport}>
                        Excel Export
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(
                      PERMISSION_MANAGE_DELETED_CUSTOMERS
                    ) ? (
                      <Link class="dropdown-item" to="/deleted-customers">
                        Manage Deleted Customers
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_CLEANUP_OLD_CUSTOMERS) ? (
                      <Link
                        to="#"
                        title="Cleanup old Customers"
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#CleanupConfirmationModal"
                      >
                        Cleanup old Customers
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(
                      PERMISSION_CUSTOM_FIELD_CONFIGURATION
                    ) ? (
                      <Link
                        to="/custom-field-configuration"
                        title="Custom Field Configuration"
                        className="dropdown-item"
                      >
                        Customer Custom Fields
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                </div> */}
              {/* </div> */} 

              {checkUserPermission(PERMISSION_ADD) ? (
                <Link
                  to="/manage-adjustment"
                  className="btn btn-added pull-right"
                >
                  <i className="fa fa-plus me-2 lg"></i>
                  Add New
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
          {/* <Link
            to="/customer-intake-form"
            className="btn btn-primary pull-right ms-2"
          >
            <i className="fa fa-download me-2 lg"></i>
            Customer Intake Form
          </Link>
          <Link
            to="/import-excel-customers"
            className="btn btn-primary pull-right ms-2"
          >
            <i className="fa fa-upload me-2 lg"></i>
            Excel Import
          </Link>
          <Link
            className="btn btn-primary pull-right ms-2"
            onClick={handleExcelExport}
          >
            <i className="fa fa-download me-2 lg"></i>
            Excel Export
          </Link>
          <Link
            to="/deleted-customers"
            className="btn btn-primary pull-right ms-2"
          >
            <i className="fa fa-trash me-2 lg"></i>
            Manage Deleted Customers
          </Link>
          <Link
            to="#"
            title="Cleanup old Customers"
            className="btn btn-primary pull-right mb-2 ms-2"
            data-bs-toggle="modal"
            data-bs-target="#CleanupConfirmationModal"
          >
            <i
              className="fa fa-trash me-2 lg"
              data-bs-toggle="tooltip"
              title="Cleanup old Customers"
            ></i>
            Cleanup old Customers
          </Link>
          <Link
            to="/custom-field-configuration"
            title="Custom Field Configuration"
            className="btn btn-primary pull-right ms-2"
            // data-bs-toggle="modal"
            // data-bs-target="#CustomFieldConfiguration"
          >
            <i
              className="fa fa-trash me-2 lg"
              data-bs-toggle="tooltip"
              title="Custom Field Configuration"
            ></i>
            Custom Field Configuration
          </Link>
          <br />
          <br /> */}
          <div className="row mt-2">
            <div className="col-lg-12 col-md-6 col-sm-12">
              <div className="d-flex flex-wrap">
              <div className="p-3 col-lg-2 col-md-6 col-sm-12 mt-2 ">
                  <input
                    type="search"
                    placeholder="Search..."
                    className="search-btn form-control form-control-sm w-100 pull-right"
                    onChange={ChangeFilterText}
                    value={searchtext}
                  />
                </div>
                <div className="p-2 mt-3 col-lg-2 col-md-6 col-sm-12 ">
                  <Select
                    defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleQuickBookChange("ExcelExport", event);
                    }}
                    options={options}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    // hideSelectedOptions={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                    id="ExcelExport"
                    name="ExcelExport"
                  />
                </div>
                {quickBookOptions?.value == 2 && (
                  <>
                    <div className="p-3 col-lg-2 col-md-6 col-sm-12">
                      Custom Start Date:
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        id="StartDate"
                        name="StartDate"
                        onChange={(event) =>
                          handleChangeCustomStartingDate(event)
                        }
                      />
                    </div>
                    <div className="p-3 col-lg-2 col-md-6 col-sm-12">
                      Custom End Date:
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        id="EndDate"
                        name="EndDate"
                        onChange={(event) =>
                          handleChangeCustomEndingDate(event)
                        }
                      />
                    </div>
                    <div className="p-3 col-lg-1 col-md-6 col-sm-12 mt-3">
                  <button
                    className="btn btn-dark btn-sm"
                    onClick={() => handleSearchAccordingToDate()}
                  >
                    Search
                  </button>
                </div>
                  </>
                )}
               
               
                {quickBookOptions?.value !== 2 && (
                  <>
                    <div className="p-3 col-lg-4 col-md-3 col-sm-12"></div>
                  </>
                )}
               
              </div>
            </div>
          </div>

          {/* Customer list */}
          {/* <div className="card"> */}
            <div className="card-body">
            <div className="email-header">
                  <div className="row ">
                    <div className="col-lg-200 top-action-left col-sm-20">
                    <div className="float-left">
                <DataTable
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  // fixedHeader
                  // fixedHeaderScrollHeight="70vh"
                  persistTableHead
                  sortServer
                  onSort={handleSort}
                //   selectableRows
                  // onSelectedRowsChange={e => { handleSelectedRowsChange(e); }}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                />
                {/* <Table columns={columns} dataSource={data} /> */}
              </div>
              </div>
            </div>
          </div>
          </div>
          </div>
        </div>
      {/* </div> */}

      {/* Delete Model  */}
      <DeleteAccountConfirmation
        deleteApiUrl={`${config.accountingBaseUrl}/chartofaccounts/inventoryquantitydelete`}
      />

      {/* Cleanup old customer */}
      <CleanupConfirmationModal
        CleanupConformationApiUrl={`${config.customersBaseUrl}/customers/cleanupcustomer`}
      />
      <SkipbarcodeConfirmationModal
      // CleanupConformationApiUrl={`${config.customersBaseUrl}/customers/cleanupcustomer`}
      // onClick={handlebarcodesheet(selectedCustomerCheckboxs)}
      // onClick={window.location.reload()}
      />
    </>
  );
};


